'use strict';
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp from "./com.raquo.laminar.keys.-Event-Prop.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$() {
  this.yh = null;
  $n_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ = this;
  this.yh = new $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp.$c_Lcom_raquo_laminar_keys_EventProp("selection-change");
}
export { $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ as $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ as $h_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ };
$h_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$.prototype = $p;
var $d_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$, "be.doeraene.webcomponents.ui5.SideNavigation$events$", ({
  gp: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ as $d_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ };
var $n_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$;
function $m_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$)) {
    $n_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ = new $c_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ as $m_Lbe_doeraene_webcomponents_ui5_SideNavigation$events$ };
